import { RefObject, createContext, useContext } from 'react';

export interface ListScreenContextValue {
  scrollNode: HTMLDivElement | null;
  setScrollNode: (node: HTMLDivElement | null) => void;
  triggerRef: RefObject<HTMLDivElement | null>;
}

export const ListScreenContext = createContext<ListScreenContextValue | null>(null);

export const useListScreenContext = () => {
  const context = useContext(ListScreenContext);

  if (!context) {
    throw new Error('useListScreenContext must be used within a ListScreen');
  }

  return context;
};
